
import { Auth } from '@aws-amplify/auth';
import React, { createContext, useContext ,useEffect,useState} from 'react';
import { IAttributes, getAttr } from "../config/iattributes";


const AuthenticationContext = createContext([{}, () => {}]);

export const AuthenticationProvider = ({ children }) => {

    const key = 'configuration';

    const [globalConfig, setGlobalConfig] = useState({
        name: '',
        pixelstreamingUrl:'' ,
        backgroundImageUrl: '',
        actor: '',
        user: null,
        attributes: null,
        tenants: '',
        groups: '',
        options: '',
        isDisabled: false,
        micIsDisabled : false,
        pushToTalk : false,
        hideSpeechToTextInfo: false,
        hideStreamingInfo: false,
        actorName: ''
      });

    useEffect(()=>{
        setConfig(globalConfig);

    }, [ globalConfig, setGlobalConfig  ]);

    const updateConfig = (newConfig) => {
        setGlobalConfig({ ...globalConfig, ...newConfig });
        setConfig(newConfig);
      };

    const getConfig = () => {
        const stickyValue = window.localStorage.getItem(key);
        return stickyValue !== null ? JSON.parse(stickyValue) : null;
    }

    const setConfig = (config) => {
        console.log("SET LOCAL STORAGE",config);
        window.localStorage.setItem(key,JSON.stringify(config));
    }

    const check = () =>  {
        return new Promise((resolve,reject)=> {
            Auth.currentAuthenticatedUser({
                bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            }).then(user => {
                if (user !== '') {
                    
                   
                    Auth.userAttributes(user).then(attr => {
                        
                        let isDisabled = false;
                        let micIsDisabled = false;
                        let pushToTalk = false;
                        let hideSpeechToTextInfo = false;
                        let hideStreamingInfo = false;
                        let actorName = '';
                        let attributes = [];
    
                        let defaultActor = getAttr(attr,IAttributes.Actor);
                        let defaultPixelStreaming = getAttr(attr,IAttributes.PixelStreaming);
                        let defaultPixelBackgroundImage = getAttr(attr,IAttributes.BackgroundImage);
                        let defaultOptions = getAttr(attr,IAttributes.Options);
    
                        if(defaultActor !== null && defaultActor !== undefined) {
                            attributes[IAttributes.Actor] = defaultActor;
                        }
    
                        if(defaultPixelStreaming !== null && defaultPixelStreaming !== undefined ) {
                            console.log("PIXLESTREAMING OPTIONS",defaultPixelStreaming);
                            attributes[IAttributes.PixelStreaming] = defaultPixelStreaming;
                        }
    
                        if(defaultPixelBackgroundImage !== null && defaultPixelBackgroundImage !== undefined  ) {
                            attributes[IAttributes.BackgroundImage] = defaultPixelBackgroundImage;
                        }


                        if (defaultOptions !== null && defaultOptions !== undefined  ){
                            let options = {};
                            let optionsArray = defaultOptions.split(',');
                            optionsArray.forEach(element => {
                                let opt = element.split(":");
                                let val = opt[1].trim();
                                options[opt[0]] = val;

                                // for compatibility management
                                if(opt[0] === 'ACTOR') {
                                    attributes[IAttributes.Actor] = val;
                                }

                                if(opt[0] === 'DISABLED') {
                                        if (val === '1') isDisabled = true;
                                }

                                if(opt[0] === 'NOMIC') {
                                    if (val === '1') micIsDisabled = true;
                                }

                                if(opt[0] === 'PTT') {
                                    if (val === '1') pushToTalk = true;
                                }

                                if(opt[0] === 'TRLS_INFO') {
                                    if (val === '1') hideSpeechToTextInfo = true;
                                }
            
                                if(opt[0] === 'STREAM_INFO') {
                                    if (val === '1') hideStreamingInfo = true;
                                }

                                if(opt[0] === 'USE_NAME') {
                                    if (val !== '') actorName = opt[1];
                                }




                            });
                            attributes[IAttributes.Options] = options;
                        }


    
                        attributes[IAttributes.GivenName] = getAttr(attr,IAttributes.GivenName);
                        attributes[IAttributes.FamilyName] = getAttr(attr,IAttributes.FamilyName);
                        attributes[IAttributes.Tenants] = getAttr(attr,IAttributes.Tenants);
    
                        let groups = user.signInUserSession.accessToken.payload['cognito:groups']

                        
                        let userData = globalConfig;


                        if (attributes[IAttributes.PixelStreaming] === undefined) attributes[IAttributes.PixelStreaming] = userData.pixelstreamingUrl;
                        if (attributes[IAttributes.BackgroundImage] === undefined) attributes[IAttributes.BackgroundImage] = userData.backgroundImageUrl;
                        if (attributes[IAttributes.Actor] === undefined) attributes[IAttributes.Actor] = userData.actor;
                        if (attributes[IAttributes.Tenants] === undefined) attributes[IAttributes.Tenants] = userData.tenants;
                        if (attributes[IAttributes.Options] === undefined) attributes[IAttributes.Options] = userData.options;
     

                        userData.user               = user.username;
                        userData.name               = attributes[IAttributes.GivenName] + ' ' + attributes[IAttributes.FamilyName];
                        userData.pixelstreamingUrl  = attributes[IAttributes.PixelStreaming];
                        userData.backgroundImageUrl = attributes[IAttributes.BackgroundImage];
                        userData.actor              = attributes[IAttributes.Actor];
                        userData.attributes         = attributes;
                        userData.tenants            = attributes[IAttributes.Tenants];
                        userData.groups             = groups;
                        userData.options            = attributes[IAttributes.Options];
                        userData.isDisabled         = isDisabled;
                        userData.micIsDisabled      = micIsDisabled;
                        userData.pushToTalk         = pushToTalk;
                        userData.hideSpeechToTextInfo = hideSpeechToTextInfo;
                        userData.hideStreamingInfo = hideStreamingInfo;
                        userData.actorName         = actorName;
                        

                        updateConfig(userData);
                        resolve(userData);

                    }).catch(err => {
                        reject(false);
                    });               
                }
            }).catch(err =>{
                reject(false);
        });

        });

    };

    return (
        <AuthenticationContext.Provider value={{ getConfig, updateConfig ,check  }}>
          {children}
        </AuthenticationContext.Provider>
      );
}

export const useAuthentication = () =>  { 
    const context = useContext(AuthenticationContext);
    if (!context) {
        throw new Error("userAuthentication must be used within a AuthenticationProvider");
    }

    return context;
}